module.exports = __webpack_public_path__ + "img/PlayNow.ce5f06ef.png";